export default "__VITE_ASSET__BF3WtfVx__"